import { render, staticRenderFns } from "./GenericVForm.vue?vue&type=template&id=ba721396&scoped=true&"
import script from "./GenericVForm.vue?vue&type=script&lang=js&"
export * from "./GenericVForm.vue?vue&type=script&lang=js&"
import style0 from "./GenericVForm.vue?vue&type=style&index=0&id=ba721396&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba721396",
  null
  
)

export default component.exports